export default __webpack_public_path__ + "static/media/capablanca.3998d021.txt";